import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FORMS } from '../../forms';
import { FieldSet, OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';
import { UbsBlogService } from '../../../services/ubs-blog.service';
import { NbGlobalPhysicalPosition, NbToastrService } from '@nebular/theme';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SelectedValue } from '@urbannex/view-containers';
import { take } from 'rxjs';

@Component({
  selector: 'ubs-blog-webcontent',
  templateUrl: './ubs-blog-webcontent.component.html',
  styleUrls: ['./ubs-blog-webcontent.component.scss']
})
export class UbsBlogWebcontentComponent implements OnChanges{
  @Input() blogContentId:string;
  addForm = new OfbizForm({
    formName:"BlogWebContent",
    local:true,
    formLocation:"component://kwikstore/widget/WebSiteContentForms.xml",
    appContext:"content",
    layout:"SingleColumn",
    fields:this.blogService.getFields("BlogWebContent",FORMS),
    fieldSets:this.getFieldSets("BlogWebContent",FORMS),
    target:this.blogService.getTarget("BlogWebContent",FORMS),
    targets:this.blogService.getTargets("BlogWebContent",FORMS),
    titleDescriptionField:"contentName",
    idFieldName:"contentId"
  })

  title="Remove Blog";
  state=null;
  target:string; // = this.setTarget(this.addForm);
  parameters:any[]=[];
  lookupSelectedValue:any;
  tempForm = this.fb.group({}); // Used to get the default value from backend
  hasValue:boolean = false;

  positions = NbGlobalPhysicalPosition;

  constructor(private blogService:UbsBlogService,
    private route:ActivatedRoute,
    private fb:FormBuilder,
    private ofbizFormsService:OfbizFormsService,
    private toastrService: NbToastrService){

  }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["blogContentId"]){
      let parameters = {};
      parameters["blogContentId"] = this.blogContentId;
      this.populateParameters(parameters);
      this.target = "updateBlog";
      this.getValue(this.addForm)
    }
  }

  getFieldSets(formName:string,FORMS):FieldSet[]{
    let fieldSets = [];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    fieldSets = localForm.fieldSets;
    return fieldSets;
  }

  setTarget(addForm:OfbizForm):string{
    let target = "";
    let targets = addForm.targets? addForm.targets : null;
    if(targets != null){
      console.log({Targets:targets});
      target = targets["updateTarget"];
    }else if(this.addForm.target != null && this.addForm.target != undefined){
      console.log({"NoTARGETS":addForm.formName})
      target = this.addForm.target;
    }else{
      console.log({"NoTarget":addForm.formName})
    }
    return target
  }

  populateParameters(parameters:any){
    if(parameters != undefined){
      Object.keys(parameters).forEach(key =>{
        this.tempForm.addControl(key,new FormControl(parameters[key]));
      });
    }
  }

  openDialogContainer(e){

  }

  getValue(addForm:OfbizForm){
    let selectedValue:SelectedValue = {
      event:"edit",
      type:"",
      data:{
        formData:{
          formName:addForm.formName,
          formLocation:addForm.formLocation
        }
      }
    };
    console.log({ofbizForm:addForm});
    console.log({tempForm:this.tempForm});
    let formData = selectedValue.data.formData;
    this.ofbizFormsService.getValue(formData,this.tempForm.value,null)
    .pipe(take(1))
    .subscribe(responseData => {
      const statusCode = responseData["statusCode"];
      console.log(statusCode);
      switch (statusCode) {
        case 200:
          if(responseData["successMessage"] == "OK"){
            const data = responseData["data"];
            const formData = data["formData"];
            if(data["responseMessage"] == "success"){
              //this.responseMessage = "success";
              //let formFields:OfbizField[] = this.addForm.fields;
              let dataFields:any[] = formData["fields"];
              this.parameters = dataFields;
              let titlePlaceHolder = ""
              this.addForm.fields.forEach(field => {
                console.log(field);
                let dataField = dataFields.find(element => field.name == Object.keys(element)[0]);
                if(dataField){
                  field.value = dataField[field.name];
                  if(field.name == "contentName"){
                    titlePlaceHolder = dataField[field.name];
                  }
                }
              });
              console.log({AddFormAfter:this.addForm});
              this.title = this.title+" : "+titlePlaceHolder;
              this.hasValue = true;
            }
          }
          break;
        case 404:
        
          break;
        case 500:
        
          break;
        default:
          break;
      }
    })
  }
  /**
   * 
   * @param $event Result of form submissions
   */
  submitResult(e){
    let position = this.positions.TOP_RIGHT;
    let status = "";
    if(e === "success"){
      status = "success";
      this.toastrService.show("Article successfully updated","Blog Article Update",{position, status});
    }
  }
}
